import jbs_api from "@/modules/jbs-api";
import { map } from "lodash-es";

export default {
  namespaced: true,
  state: {
    lists: [], // All our lists
    active_list: false, // Currently editing list
    uncommitted: false, // We have local changes which aren't synced to server
    saving: false, // Waiting for server response
    _last_added_to: false, // List which we last added an item to
    last_request_time: false, // Timestamp of last request
    presentation_mode: false
  },
  getters: {
    is_template_enabled: state => template => {
      if (!state.active_list) {
        return false;
      }
      return state.active_list.settings.templates.indexOf(template) !== -1;
    },
    get_template: state => template => {
      if (!state.active_list) {
        return [];
      }
      return state.active_list.templates[template];
    },
    last_added_to(state) {

      if (!state._last_added_to || !state.lists || state.lists.length === 0) {
        return false;
      }

      for (var i in state.lists) {
        if (state.lists[i].id === state._last_added_to.id) {
          return state._last_added_to;
        }
      }

      return { id: state.lists[0].id, list_title: state.lists[0].list_title };
    },
    editable_lists(state) {
      return map(state.lists, function (o) {
        if (o.can_edit) {
          return o;
        }
      })
    }
  },
  mutations: {
    set_presentation_mode(state, payload) {
      state.presentation_mode = payload;
    },
    new_request_time(state) {
      state.last_request_time = Date.now();
    },
    update_template(state, payload) {
      state.uncommitted = true;
      state.active_list.templates[payload.template] = payload.items;
    },
    uncommitted(state, payload) {
      state.uncommitted = payload;
    },
    saving(state, payload) {
      state.saving = payload;
    },
    update_lists(state, payload) {
      if (!payload) {
        return false;
      }

      if (payload["@ts"]) {
        delete payload["@ts"];
      }

      state.lists = payload;
    },
    set_active_list(state, payload) {
      state.active_list = payload;
    },
    reset_active_list(state) {
      state.active_list = false;
    },
    set_active_list_from_response(state, payload) {
      if (state.last_request_time <= payload.headers["x-zux-origin-time"]) {
        state.active_list = payload.data;
        state.saving = false;
        state.uncommitted = false;
      } else {
        console.log("Skipped model update as a request is pending");
      }
    },
    set_last_added_to(state, payload) {
      state._last_added_to = payload;
    }
  },
  actions: {
    update_item(context, payload) {
      payload._action = "item";
      context.commit("saving", true);
      context.commit("uncommitted", true);
      context.commit("new_request_time");
      return jbs_api
        .patch("WineList", payload, {
          origin_time: context.state.last_request_time
        })
        .then(function (response) {
          context.commit("set_active_list_from_response", response);
        });
    },
    update_order(context, payload) {
      payload._action = "order";
      context.commit("uncommitted", true);
      context.commit("saving", true);
      context.commit("new_request_time");
      return jbs_api
        .patch("WineList", payload, {
          origin_time: context.state.last_request_time
        })
        .then(function (response) {
          context.commit("set_active_list_from_response", response);
        });
    },
    hide_item(context, payload) {
      payload._action = "hide";
      context.commit("uncommitted", true);
      context.commit("saving", true);
      context.commit("new_request_time");
      return jbs_api
        .patch("WineList", payload, {
          origin_time: context.state.last_request_time
        })
        .then(function (response) {
          context.commit("set_active_list_from_response", response);
        });
    },
    remove_item(context, payload) {
      payload._action = "remove";
      context.commit("uncommitted", true);
      context.commit("saving", true);
      context.commit("new_request_time");
      return jbs_api
        .patch("WineList", payload, {
          origin_time: context.state.last_request_time
        })
        .then(function (response) {
          context.commit("set_active_list_from_response", response);
        });
    },
    update_active_items(context, payload) {
      context.commit("update_template", payload);
      return context.dispatch("save_active_list", context.state.active_list);
    },
    create_new_list(context, payload) {
      return jbs_api.post("WineList", payload).then(function (response) {
        context.commit("update_lists", response.state);
        context.commit("set_active_list", response.data);
      });
    },
    duplicate_list(context, payload) {
      return jbs_api.post("WineList/Duplicate", payload).then(function (response) {
        context.commit("update_lists", response.state);
        context.commit("set_active_list", response.data);
        return response;
      });
    },
    delete_list(context, payload) {
      return jbs_api
        .delete("WineList", { params: payload })
        .then(function (response) {
          context.commit("update_lists", response.state);
          context.commit("set_active_list", response.data);
        });
    },
    save_active_list(context, payload) {
      payload._action = "legacy";
      context.commit("uncommitted", true);
      context.commit("saving", true);
      context.commit("new_request_time");
      return jbs_api
        .patch("WineList", payload, {
          origin_time: context.state.last_request_time
        })
        .then(function (response) {
          context.commit("set_active_list_from_response", response);
        });
    },
    save_margins(context, payload) {
      payload._action = "margins";
      context.commit("uncommitted", true);
      context.commit("saving", true);
      context.commit("new_request_time");
      return jbs_api
        .patch("WineList", payload, {
          origin_time: context.state.last_request_time
        })
        .then(function (response) {
          context.commit("set_active_list_from_response", response);
        });
    },
    add_to_list(context, payload) {
      return jbs_api.put("WineList", payload);
    },
    load_and_activate_full_list(context, payload) {
      return jbs_api
        .get("WineList", { params: { slug: payload } })
        .then(response => {
          context.commit("update_lists", response.state);
          context.commit("set_active_list", response.data);
        });
    }
  }
};
